var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "font-alignement"
  }, [_c('v-icon', {
    attrs: {
      "color": this.alignement == 'left' ? 'primary' : 'black'
    },
    on: {
      "click": function click($event) {
        return _vm.setAlign('left');
      }
    }
  }, [_vm._v("mdi-format-align-left")]), _c('v-icon', {
    attrs: {
      "color": this.alignement == 'center' ? 'primary' : 'black'
    },
    on: {
      "click": function click($event) {
        return _vm.setAlign('center');
      }
    }
  }, [_vm._v("mdi-format-align-center")]), _c('v-icon', {
    attrs: {
      "color": this.alignement == 'right' ? 'primary' : 'black'
    },
    on: {
      "click": function click($event) {
        return _vm.setAlign('right');
      }
    }
  }, [_vm._v("mdi-format-align-right")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }